import { Stack } from '@mui/material';
import { Logo } from './Logo';
import { Intro } from './Intro';
import { Outro } from './Outro';

export const Landing = () => {
  return (
    <Stack
      alignItems='center'
      sx={{
        p: '40px 42px',
        maxWidth: '400px',
        bgcolor: '#E7EDFF',
        textAlign: 'center',
      }}
    >
      <Logo />
      <Intro />
      <Outro />
    </Stack>
  );
};
